export default __webpack_public_path__ + "static/media/mobile_20s@3x.a2e88b90.jpg";